import {
  bootstrapFlexSettingsOptions,
  tailwindFlexSettingsOptions,
} from '@helpers/css-library.js';

const DEFAULT_STATE = {
  defaultCssLibrary: 'bootstrap',
  cssLibrary: {
    tailwind: {
      'b3rg/section': {
        containerType: {
          options: [
            { label: 'Container', value: 'container' },
            { label: 'Fluid Container', value: '' },
          ],
        },
      },
      'b3rg/row': {
        displayTypeClass: {
          options: [
            { label: 'flex', value: 'flex' },
            { label: 'grid', value: 'grid' },
          ],
        },
        childBlocksDirectionClass: {
          options: [
            { label: 'Select Class', value: '' },
            { label: 'SM Row Reverse', value: 'sm:flex-row-reverse' },
            { label: 'MD Row Reverse', value: 'md:flex-row-reverse' },
            { label: 'LG Row Reverse', value: 'lg:flex-row-reverse' },
            { label: 'XL Row Reverse', value: 'xl:flex-row-reverse' },
          ],
        },
        childBlocksHorizontalAlignClass: {
          options: [
            { label: 'Select Class', value: '' },
            {
              label: 'Justify Content Start',
              value: 'justify-start',
            },
            {
              label: 'Justify Content End',
              value: 'justify-end',
            },
            {
              label: 'Justify Content Center',
              value: 'justify-center',
            },
            {
              label: 'Justify Content Between',
              value: 'justify-between',
            },
            {
              label: 'Justify Content Around',
              value: 'justify-around',
            },
          ],
        },
      },
      'b3rg/column': {
        columnSize: {
          options: {
            xs: 0,
            sm: 12,
            md: 0,
            lg: 0,
            xl: 0,
            xxl: 0,
          },
        },
        flexSettings: {
          options: {
            xs: tailwindFlexSettingsOptions('xs'),
            sm: tailwindFlexSettingsOptions('sm'),
            md: tailwindFlexSettingsOptions('md'),
            lg: tailwindFlexSettingsOptions('lg'),
            xl: tailwindFlexSettingsOptions('xl'),
            xxl: tailwindFlexSettingsOptions('xxl'),
          },
        },
      },
      'b3rg/div': {
        columnSize: {
          options: {
            xs: 0,
            sm: 12,
            md: 0,
            lg: 0,
            xl: 0,
            xxl: 0,
          },
        },
        flexSettings: {
          options: {
            xs: tailwindFlexSettingsOptions('xs'),
            sm: tailwindFlexSettingsOptions('sm'),
            md: tailwindFlexSettingsOptions('md'),
            lg: tailwindFlexSettingsOptions('lg'),
            xl: tailwindFlexSettingsOptions('xl'),
            xxl: tailwindFlexSettingsOptions('xxl'),
          },
        },
      },
    },
    bootstrap: {
      'b3rg/section': {
        containerType: {
          options: [
            { label: 'Container', value: 'container' },
            { label: 'Fluid Container', value: 'container-fluid' },
          ],
        },
      },
      'b3rg/row': {
        displayTypeClass: {
          options: [
            { label: 'row', value: 'row' },
            { label: 'grid', value: 'grid' },
          ],
        },
        childBlocksDirectionClass: {
          options: [
            { label: 'Select Class', value: '' },
            { label: 'SM Row Reverse', value: 'flex-sm-row-reverse' },
            { label: 'MD Row Reverse', value: 'flex-md-row-reverse' },
            { label: 'LG Row Reverse', value: 'flex-lg-row-reverse' },
            { label: 'XL Row Reverse', value: 'flex-xl-row-reverse' },
          ],
        },
        childBlocksHorizontalAlignClass: {
          options: [
            { label: 'Select Class', value: '' },
            {
              label: 'Justify Content Start',
              value: 'justify-content-start',
            },
            {
              label: 'Justify Content End',
              value: 'justify-content-end',
            },
            {
              label: 'Justify Content Center',
              value: 'justify-content-center',
            },
            {
              label: 'Justify Content Between',
              value: 'justify-content-between',
            },
            {
              label: 'Justify Content Around',
              value: 'justify-content-around',
            },
          ],
        },
      },
      'b3rg/column': {
        columnSize: {
          options: {
            xs: 0,
            sm: 12,
            md: 0,
            lg: 0,
            xl: 0,
            xxl: 0,
          },
        },
        flexSettings: {
          options: {
            xs: bootstrapFlexSettingsOptions(''),
            sm: bootstrapFlexSettingsOptions('sm'),
            md: bootstrapFlexSettingsOptions('md'),
            lg: bootstrapFlexSettingsOptions('lg'),
            xl: bootstrapFlexSettingsOptions('xl'),
            xxl: bootstrapFlexSettingsOptions('xxl'),
          },
        },
      },
      'b3rg/div': {
        columnSize: {
          options: {
            xs: 0,
            sm: 12,
            md: 0,
            lg: 0,
            xl: 0,
            xxl: 0,
          },
        },
        flexSettings: {
          options: {
            xs: bootstrapFlexSettingsOptions(''),
            sm: bootstrapFlexSettingsOptions('sm'),
            md: bootstrapFlexSettingsOptions('md'),
            lg: bootstrapFlexSettingsOptions('lg'),
            xl: bootstrapFlexSettingsOptions('xl'),
            xxl: bootstrapFlexSettingsOptions('xxl'),
          },
        },
      },
    },
  },
};

export default DEFAULT_STATE;
